export default __webpack_public_path__ + "static/media/loading.20416be4.svg";